const translation = {
  custom: 'Налаштування',
  upgradeTip: {
    prefix: 'Оновіть свій план до ',
    suffix: ', щоб налаштувати свій бренд.',
    title: 'Оновіть свій план',
    des: 'Оновіть свій план, щоб налаштувати свій бренд',
  },
  webapp: {
    title: 'Налаштувати бренд для web app',
    removeBrand: 'Видалити Powered by Dify',
    changeLogo: 'Змінити зображення бренду "Powered by"',
    changeLogoTip: 'Формат SVG або PNG з мінімальним розміром 40x40 пікселів',
  },
  app: {
    title: 'Налаштувати бренд заголовка програми app',
    changeLogoTip: 'Формат SVG або PNG з мінімальним розміром 80x80 пікселів',
  },
  upload: 'Завантажити',
  uploading: 'Завантаження',
  uploadedFail: 'Помилка завантаження зображення, будь ласка, завантажте ще раз.',
  change: 'Змінити',
  apply: 'Застосувати',
  restore: 'Відновити значення за замовчуванням',
  customize: {
    contactUs: 'зв\'яжіться з нами',
    prefix: 'Щоб налаштувати логотип бренду в програмі, будь ласка,',
    suffix: 'щоб перейти на корпоративне видання.',
  },
}

export default translation
